import { SortInput } from '@apeiron/common'
import { StarFilterInput, StarSortBy } from '@apeiron/star'
import { useAccountContext } from '@apeiron/temp'
import SaveFilter from '@src/components/share/filter/saveFilter/SaveFilter'
import StarConstellationFilter from '@src/components/stars/list/filter/constellationFilter/StarConstellationFilter'
import StarOthersFilter from '@src/components/stars/list/filter/StarOthersFilter'
import StarSlotFilter from '@src/components/stars/list/filter/StarSlotFilter'
import StarTypeAndEffectFilter from '@src/components/stars/list/filter/StarTypeAndEffectFilter'
import { FavoriteType } from '@src/constants/favoriteFilter'
import { FC, useCallback } from 'react'

const StarFilter: FC<Props> = (props: Props) => {
  const { allowFavorite = true, filterInput, sortInput, onFilterChange } = props

  const { isLoggedIn } = useAccountContext()

  const handleOnFilterByFavorite = useCallback(
    (filter: StarFilterInput, sort: SortInput<StarSortBy>) => {
      onFilterChange(filter, sort)
    },
    [onFilterChange]
  )

  return (
    <>
      {allowFavorite && isLoggedIn && (
        <SaveFilter
          type={FavoriteType.Star}
          filterInput={filterInput}
          sortInput={sortInput}
          onFilterByFavorite={handleOnFilterByFavorite}
        />
      )}

      <StarTypeAndEffectFilter
        filterInput={filterInput}
        onFilterChange={onFilterChange}
      />
      <StarConstellationFilter
        filterInput={filterInput}
        onFilterInputChange={onFilterChange}
      />
      <StarSlotFilter
        filterInput={filterInput}
        onFilterChange={onFilterChange}
      />
      <StarOthersFilter
        filterInput={filterInput}
        onFilterChange={onFilterChange}
      />
    </>
  )
}

type Props = {
  allowFavorite?: boolean
  filterInput: StarFilterInput
  sortInput: SortInput<StarSortBy>
  onFilterChange: (input: StarFilterInput, sort?: SortInput<StarSortBy>) => void
}

export default StarFilter
